import apiClient from "../helpers/ApiClient";
import { handleError, authHeader } from "../helpers/ApiClient";

export const organisationService = {
  getOrganisation,
  updateOrganisation,
  createOrg
};

function getOrganisation() {
  return apiClient
    .get("/org", { headers: authHeader() })
    .then((response) => {
      return response.data;
    })
    .catch((error) => handleError(error));
}

function updateOrganisation(organisation) {
  const body = {
    ...organisation,
    ticketHeaderText: organisation.ticketHeaderText ?? "",
    ticketFooterText: organisation.ticketFooterText ?? "",
  };
  return apiClient
    .patch("/org", body, { headers: authHeader() })
    .then((response) => {
      return response.data;
    })
    .catch((error) => handleError(error));
}

function createOrg(organisation) {
    return apiClient
        .post("/org/create", organisation, { headers: authHeader() })
        .then((response) => {
            return response.data;
        })
        .catch((error) => handleError(error));
}